import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AccountSelect = ({ accounts, value, onChange, allowAll, testId, placeholder = "Select account" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="bg-slate-900/60 border-slate-700 min-w-[200px]">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {allowAll && <SelectItem value="all">All accounts</SelectItem>}
      {accounts.map((a) => (
        <SelectItem key={a.id} value={a.id}>{a.broker} · {a.account_number}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
